//basice module
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';

//service
import { WindowService } from './window.service';
import { ApiService } from './api.service';
import { UiService } from './ui.service';
import { AppServiceService } from './app-service.service';

//resolve
import { HomeResolve } from './resolves/home.resolve';
import { AboutResolve } from './resolves/about.resolve';
import { CollectionsPage } from './resolves/collections_page.resolve';
import { PhilosophyResolve } from './resolves/philosophy.resolve';
import { QualityResolve } from './resolves/quality.resolve';
import { FairTradeResolve } from './resolves/fareTrade.resolve';
import { CollectionTermResolve } from './resolves/collection_term.resolve';
import { DesignersResolve } from './resolves/designers.resolve';
import { DesignerResolve } from './resolves/designer.resolve';
import { CustomOrderResolve } from './resolves/customOrder.resolve';
import { BlogResolve } from './resolves/blog.resolve';
import { PressResolve } from './resolves/press.resolve';
import { PostResolve } from './resolves/post.resolve';
import { ContactResolve } from './resolves/contact.resolve';
import { ThemesSettings } from './resolves/themes_setting.resolve';
import { Page404Resolve } from './resolves/page404';

//component
import { AppComponent } from './app.component';
import { CollectionComponent } from './collection/collection/collection.component';
import { HomeComponent } from './home/home/home.component';
import { AppRoutingModule } from './app-routing.module';
import { MenuComponent } from './common/menu/menu.component';
import { LeftSideComponent } from './common/left-side/left-side.component';
import { AboutComponent } from './about/about.component';
import { BlogComponent } from './blog/blog/blog.component';
import { PressComponent } from './blog/press/press.component';
import { ContactComponent } from './contact/contact/contact.component';
import { ContactFormComponent } from './contact/contact-form/contact-form.component';
import { PostComponent } from './blog/post/post.component';
import { FairTradeComponent } from './fair-trade/fair-trade.component';
import { PostCollectionComponent } from './collection/post-collection/post-collection.component';
import { DesignersComponent } from './designers/designers.component';
import { PostDesignerComponent } from './designers/post-designer/post-designer.component';
import { QualityComponent } from './quality/quality.component';
import { CustomOrderComponent } from './custom-order/custom-order.component';
import { PhilosophyComponent } from './philosophy/philosophy.component';
import { HttpClientModule } from '@angular/common/http';
import { Page404Component } from './page404/page404.component';
import { AnimateService } from './animate.service';

@NgModule({
  declarations: [
    AppComponent,
    CollectionComponent,
    HomeComponent,
    MenuComponent,
    LeftSideComponent,
    AboutComponent,
    BlogComponent,
    PressComponent,
    ContactComponent,
    ContactFormComponent,
    PostComponent,
    FairTradeComponent,
    PostCollectionComponent,
    DesignersComponent,
    PostDesignerComponent,
    QualityComponent,
    CustomOrderComponent,
    PhilosophyComponent,
    Page404Component
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule
  ],
  providers: [
    CookieService,
    ApiService,
    UiService,
    AppServiceService,
    WindowService,
    HomeResolve,
    AboutResolve,
    CollectionsPage,
    CollectionTermResolve,
    PhilosophyResolve,
    QualityResolve,
    FairTradeResolve,
    DesignersResolve,
    DesignerResolve,
    CustomOrderResolve,
    BlogResolve,
    PressResolve,
    PostResolve,
    ContactResolve,
    ThemesSettings,
    Page404Resolve
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts